var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"coverflow",rawName:"v-coverflow"}],staticClass:"coverflow"},_vm._l((_vm.coverList),function(coverItem,index){return _c('img',{key:index,attrs:{"alt":"Image","src":coverItem.cover,"link":coverItem.package},on:{"click":function($event){return _vm.redirectLink(coverItem.package)}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }